<lib-stepper [steps]="stepLabels" [activeIndex]="stepIndex()" />

<div class="policy-bar">
  <p>
    Policy <span class="bold text-cvnavy">{{ request().policy?.policyNumber }}</span>
    <span class="text-darkgrey"> · {{ request().insuredBusinessInformation?.businessName }}</span>
  </p>
  <p class="small save-status" role="status">
    @if (store.saveError(); as error) {
      <span class="dot error"></span><span class="error-text">{{ error }}</span>
    } @else if (wizard().currentStep !== Step.Confirmation) {
      @if (loadingStore.isLoading()) {
        <span class="dot saving"></span>Saving…
      } @else {
        <span class="dot"></span>Saved automatically — you can finish later from your email link
      }
    }
  </p>
</div>

@switch (wizard().currentStep) {
  @case (Step.Operations) {
    <app-rcip-operations
      [answers]="answers()"
      [legacy]="legacy()"
      (back)="back()"
      (next)="next($event)"
    />
  }
  @case (Step.Eligibility) {
    <app-rcip-eligibility
      [request]="request()"
      (back)="back()"
      (next)="next({ eligibilityReviewed: true })"
    />
  }
  @case (Step.Classes) {
    <app-rcip-classes
      [request]="request()"
      (back)="back()"
      (next)="next({ classesReviewed: true })"
    />
  }
  @case (Step.Confirmation) {
    <app-rcip-confirmation
      [request]="request()"
      [answers]="answers()"
      [wizard]="wizard()"
      [legacy]="legacy()"
      (submit)="submit()"
    />
  }
  @default {
    <app-business-info [business]="answers().insuredBusinessInformation" (next)="next()" />
  }
}
